import { api } from '../../commonApi';
import { IGetMenuItemResponse } from '../../../proto/menu/item/menuItem';

const BASE_MENU_ITEM_URL = `menuItem`;

export const menuApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getMenuItemById: builder.query<IGetMenuItemResponse, string>({
			query: (id) => `${BASE_MENU_ITEM_URL}/${id}`,
			providesTags: (res, _, id) => [{ type: 'MenuItem', id }],
		}),
		getMenuItemsByIds: builder.query<{ menuItems: IGetMenuItemResponse[] }, { ids: string[] }>({
			query: ({ ids }) => ({
				url: `${BASE_MENU_ITEM_URL}`,
				params: { ids: ids.join(',') },
			}),
			providesTags: (res) =>
				res
					? [...res.menuItems.map(({ id }) => ({ type: 'MenuItem' as const, id })), { type: 'MenuItem', id: 'LIST' }]
					: [{ type: 'MenuItem', id: 'LIST' }],
		}),
	}),
});

export const { useGetMenuItemByIdQuery, useGetMenuItemsByIdsQuery } = menuApi;
